export default __webpack_public_path__ + "static/media/landing-bg-mobile.75a67807.jpg";